<template>
  <div class="led-screen">
    <!-- 顶部标题栏 -->
    <div class="led-header">
      <div class="header-side left-side">
        <span class="date">{{ nowDate }}</span>
        <span class="week">{{ nowWeek }}</span>
      </div>
      <div class="header-title">
        <span class="title-text">{{ pageTitle }}</span>
        <div class="title-decoration"></div>
      </div>
      <div class="header-side right-side">
        <span class="time">{{ nowTime }}</span>
      </div>
    </div>

    <!-- 主体区 -->
    <div class="led-body">
      <!-- 左侧二维码组 -->
      <div class="qr-col left">
        <div class="qr-panel" v-for="(qr, i) in qrCols.left" :key="'l' + i">
          <div class="qr-title">{{ qr.title }}</div>
          <div class="qr-subtitle">{{ qr.subtitle }}</div>
          <div class="qr-wrapper">
            <img class="qr-image" :src="qr.img" :alt="qr.title" />
            <div class="qr-corner tl"></div>
            <div class="qr-corner tr"></div>
            <div class="qr-corner bl"></div>
            <div class="qr-corner br"></div>
          </div>
          <div class="qr-tip">{{ qr.tip }}</div>
        </div>
      </div>

      <!-- 中间滚动岗位列表 -->
      <div class="job-panel">
        <div class="job-panel-header">
          <span class="panel-title">最新招聘岗位</span>
          <span class="panel-count">共 {{ totalCount }} 条</span>
        </div>
        <div class="job-list-head">
          <span class="col col-company">企业名称</span>
          <span class="col col-job">招聘岗位</span>
          <span class="col col-num">人数</span>
          <span class="col col-edu">学历</span>
          <span class="col col-salary">薪资</span>
        </div>
        <div class="job-list-viewport" ref="viewport">
          <div class="job-list-scroller"
               ref="scroller"
               :style="scrollerStyle">
            <div class="job-row"
                 v-for="(row, idx) in displayList"
                 :key="idx">
              <span class="col col-company" :title="row.Cname">{{ row.Cname || '-' }}</span>
              <span class="col col-job" :title="row.Jobname">{{ row.Jobname || '-' }}</span>
              <span class="col col-num">{{ row.Jnum || '-' }}</span>
              <span class="col col-edu">{{ row.Jeducation_CN || row.Jeducation || '不限' }}</span>
              <span class="col col-salary highlight">{{ row.Jsalary_CN || row.Jsalary || '面议' }}</span>
            </div>
            <div class="job-empty" v-if="!displayList.length">
              <span>暂无岗位数据</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧二维码组 -->
      <div class="qr-col right">
        <div class="qr-panel" v-for="(qr, i) in qrCols.right" :key="'r' + i">
          <div class="qr-title">{{ qr.title }}</div>
          <div class="qr-subtitle">{{ qr.subtitle }}</div>
          <div class="qr-wrapper">
            <img class="qr-image" :src="qr.img" :alt="qr.title" />
            <div class="qr-corner tl"></div>
            <div class="qr-corner tr"></div>
            <div class="qr-corner bl"></div>
            <div class="qr-corner br"></div>
          </div>
          <div class="qr-tip">{{ qr.tip }}</div>
        </div>
      </div>
    </div>

    <!-- 底部状态栏 -->
    <div class="led-footer">
      <span class="footer-text">扫码求职 · 岗位实时更新 · 太仓市人力资源市场</span>
    </div>
  </div>
</template>

<script>
import { getjoblist } from '@/api/scinfo/scinfo'
import sxpImg from '@/assets/images/sxp.jpg'
import ljtcImg from '@/assets/images/ljtc.jpg'
import sxp1Img from '@/assets/images/sxp1.jpg'
import sxp2Img from '@/assets/images/sxp2.jpg'

export default {
  name: 'led_screen',
  data () {
    return {
      pageTitle: '太仓市人力资源就业服务 · 招聘大屏',
      // 左右二维码组：每侧各 2 张
      qrCols: {
        left: [
          {
            title: '微信扫码',
            subtitle: '扫码进入求职端',
            tip: '苏心聘',
            img: sxpImg
          },
          {
            title: '支付宝扫码',
            subtitle: '扫码进入求职端',
            tip: '苏心聘',  // todo: 待贴 苏心聘 第2张二维码图
            img: sxp1Img
          }
        ],
        right: [
          {
            title: '求职扫码',
            subtitle: '小程序求职',
            tip: '乐就太仓',
            img: ljtcImg
          },
          {
            title: '抖音扫码',
            subtitle: '扫码进入求职端',
            tip: '就在江苏',  // todo: 待贴 乐就太仓 第2张二维码图
            img: sxp2Img
          }
        ]
      },

      // 数据
      jobList: [],
      totalCount: 0,
      pageNum: 1,
      pageSize: 100,

      // 时间
      nowDate: '',
      nowTime: '',
      nowWeek: '',

      // 滚动
      scrollOffset: 0,
      scrollTimer: null,
      refreshTimer: null,
      clockTimer: null,
      viewportHeight: 0,
      contentHeight: 0
    }
  },
  computed: {
    // 数据不足时复制一份保证滚动首尾衔接
    displayList () {
      if (!this.jobList.length) return []
      if (this.jobList.length < 10) {
        // 数据太少复制多份填满一屏
        const arr = []
        const times = Math.ceil(20 / this.jobList.length)
        for (let i = 0; i < times; i++) arr.push(...this.jobList)
        return arr
      }
      // 尾部复制一份用于无缝滚动
      return [...this.jobList, ...this.jobList]
    },
    scrollerStyle () {
      return {
        transform: `translateY(${-this.scrollOffset}px)`
      }
    }
  },
  methods: {
    // 拉岗位数据
    loadJobs () {
      getjoblist(this.pageNum, this.pageSize, '', '').then(res => {
        if (res && res.data && res.data.code === 0) {
          this.jobList = res.data.data || []
          this.totalCount = res.data.count || this.jobList.length
          // 重新计算滚动高度
          this.$nextTick(() => {
            this.recalcScrollSize()
            this.scrollOffset = 0
          })
        }
      }).catch(() => {})
    },

    recalcScrollSize () {
      if (this.$refs.viewport) {
        this.viewportHeight = this.$refs.viewport.clientHeight
      }
      if (this.$refs.scroller) {
        this.contentHeight = this.$refs.scroller.scrollHeight
      }
    },

    // 匀速滚动
    startScroll () {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        if (!this.jobList.length) return
        this.scrollOffset += 0.6 // 每帧滚动像素，值越大越快
        const half = this.contentHeight / 2
        if (half > 0 && this.scrollOffset >= half) {
          // 已滚过原始数据长度，跳回起点无缝衔接
          this.scrollOffset = 0
        }
      }, 30)
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },

    // 时钟
    updateClock () {
      const now = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      this.nowDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
      this.nowTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.nowWeek = weeks[now.getDay()]
    }
  },
  mounted () {
    // 初始化
    this.updateClock()
    this.clockTimer = setInterval(this.updateClock, 1000)
    this.loadJobs()

    // 数据每 60s 静默刷新一次
    this.refreshTimer = setInterval(() => {
      this.loadJobs()
    }, 60 * 1000)

    // 开启滚动（等首屏渲染完）
    setTimeout(() => {
      this.recalcScrollSize()
      this.startScroll()
    }, 1500)

    // 窗口大小变化重新计算
    this._resizeHandler = () => this.recalcScrollSize()
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy () {
    this.stopScroll()
    if (this.refreshTimer) clearInterval(this.refreshTimer)
    if (this.clockTimer) clearInterval(this.clockTimer)
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
  }
}
</script>

<style lang="less" scoped>
@primaryBg: #0A0F1F;
@panelBg: rgba(15, 30, 60, 0.6);
@accentColor: #00E4FF;
@textPrimary: #E8F4FF;
@textSecondary: #7C9CBF;

.led-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: @primaryBg;
  background-image:
    radial-gradient(ellipse at top, rgba(0, 100, 200, 0.25) 0%, transparent 60%),
    radial-gradient(ellipse at bottom, rgba(0, 50, 120, 0.2) 0%, transparent 60%),
    linear-gradient(180deg, #050914 0%, #0A0F1F 50%, #050914 100%);
  color: @textPrimary;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  display: flex;
  flex-direction: column;
  user-select: none;
}

/* 顶部标题栏 */
.led-header {
  height: 80px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 228, 255, 0.15);
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(90deg, transparent, @accentColor, transparent);
    opacity: 0.6;
  }

  .header-side {
    display: flex;
    align-items: center;
    gap: 16px;
    color: @textSecondary;
    font-size: 20px;
    min-width: 320px;

    .date { color: @textPrimary; letter-spacing: 2px; }
    .time { color: @accentColor; font-size: 26px; font-weight: 500; letter-spacing: 3px; }
    .week { color: @textSecondary; }
  }
  .left-side { justify-content: flex-start; }
  .right-side { justify-content: flex-end; }

  .header-title {
    flex: 1;
    text-align: center;
    position: relative;

    .title-text {
      font-size: 36px;
      font-weight: 700;
      letter-spacing: 6px;
      background: linear-gradient(180deg, #FFFFFF 0%, @accentColor 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 0 20px rgba(0, 228, 255, 0.3);
    }
    .title-decoration {
      margin: 4px auto 0;
      width: 260px;
      height: 6px;
      background: linear-gradient(90deg, transparent, @accentColor 50%, transparent);
      opacity: 0.7;
    }
  }
}

/* 主体 */
.led-body {
  flex: 1;
  display: flex;
  padding: 30px 40px;
  gap: 30px;
  min-height: 0;
}

/* 二维码列 */
.qr-col {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &.left { align-items: flex-start; }
  &.right { align-items: flex-end; }
}

/* 二维码面板 */
.qr-panel {
  width: 280px;
  flex-shrink: 0;
  background: @panelBg;
  border: 1px solid rgba(0, 228, 255, 0.25);
  border-radius: 6px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: inset 0 0 40px rgba(0, 100, 200, 0.15);

  .qr-title {
    font-size: 24px;
    font-weight: 600;
    color: @accentColor;
    letter-spacing: 4px;
    text-shadow: 0 0 10px rgba(0, 228, 255, 0.5);
  }
  .qr-subtitle {
    margin-top: 8px;
    font-size: 14px;
    color: @textSecondary;
    letter-spacing: 2px;
  }
  .qr-wrapper {
    position: relative;
    margin: 24px 0;
    padding: 14px;
    background: #FFFFFF;
    border-radius: 4px;

    .qr-image {
      display: block;
      width: 180px;
      height: 180px;
      object-fit: contain;
      background: #FFFFFF;
    }
    .qr-corner {
      position: absolute;
      width: 18px;
      height: 18px;
      border: 3px solid @accentColor;
      &.tl { top: -6px; left: -6px; border-right: none; border-bottom: none; }
      &.tr { top: -6px; right: -6px; border-left: none; border-bottom: none; }
      &.bl { bottom: -6px; left: -6px; border-right: none; border-top: none; }
      &.br { bottom: -6px; right: -6px; border-left: none; border-top: none; }
    }
  }
  .qr-tip {
    font-size: 16px;
    color: @textPrimary;
    letter-spacing: 2px;
  }
}

/* 岗位面板 */
.job-panel {
  flex: 1;
  min-width: 0;
  background: @panelBg;
  border: 1px solid rgba(0, 228, 255, 0.25);
  border-radius: 6px;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 40px rgba(0, 100, 200, 0.15);

  .job-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(0, 228, 255, 0.2);

    .panel-title {
      font-size: 28px;
      font-weight: 600;
      color: @accentColor;
      letter-spacing: 4px;
      text-shadow: 0 0 10px rgba(0, 228, 255, 0.5);

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background: @accentColor;
        vertical-align: middle;
        margin-right: 12px;
        border-radius: 2px;
      }
    }
    .panel-count {
      color: @textSecondary;
      font-size: 18px;
      letter-spacing: 2px;
    }
  }

  .job-list-head, .job-row {
    display: flex;
    align-items: center;
    padding: 0 10px;

    .col {
      padding: 0 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .col-company { flex: 3; }
    .col-job     { flex: 3; }
    .col-num     { flex: 1; text-align: center; }
    .col-edu     { flex: 1.2; text-align: center; }
    .col-salary  { flex: 1.5; text-align: center; }
  }

  .job-list-head {
    height: 54px;
    margin-top: 10px;
    background: linear-gradient(90deg, rgba(0, 228, 255, 0.15), rgba(0, 100, 200, 0.05));
    border-radius: 3px;
    color: @accentColor;
    font-size: 20px;
    letter-spacing: 2px;
    font-weight: 500;
  }

  .job-list-viewport {
    flex: 1;
    overflow: hidden;
    position: relative;
    margin-top: 8px;

    .job-list-scroller {
      will-change: transform;
      transition: none;
    }

    .job-row {
      height: 60px;
      font-size: 20px;
      color: @textPrimary;
      border-bottom: 1px dashed rgba(0, 228, 255, 0.1);

      &:nth-child(odd) {
        background: rgba(0, 228, 255, 0.03);
      }

      .col-salary.highlight {
        color: #FFD54F;
        font-weight: 600;
        text-shadow: 0 0 8px rgba(255, 213, 79, 0.3);
      }
    }

    .job-empty {
      padding: 60px 0;
      text-align: center;
      color: @textSecondary;
      font-size: 22px;
    }
  }
}

/* 底部 */
.led-footer {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @textSecondary;
  letter-spacing: 8px;
  font-size: 16px;
  border-top: 1px solid rgba(0, 228, 255, 0.15);
  flex-shrink: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(90deg, transparent, @accentColor, transparent);
    opacity: 0.4;
  }
}
</style>
